import { axiosInstance } from "../services/interceptor";
import { useMemo } from "react";

const useAddLeaveEmployee = () => {
  const addLeaveEmployee = async (data) => {
    try {
      const response = await axiosInstance.post(`/leave/add`, data);
      console.log("Add Leave Employee Response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error adding leave:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  };

  const getTicketLeaveAvailablity = async () => {
    try {
      const response = await axiosInstance.get(`/leave/availability`);
      console.log("Ticket Leave Availability Response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching ticket leave availability:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  };

  const getExperince = async (id) => {
    try {
      const response = await axiosInstance.get(`/user/getExperience/${id}`);
      console.log("Experience Response:", response.body);
      return response.data.body;
    } catch (error) {
      console.error(
        "Error fetching experience:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  };
  
  const getAnnualLeave = async () => {
    try {
      const response = await axiosInstance.get(`/leave/employee/total-balance`);
      console.log("Total Leave Balance Response:", response.data);
      return typeof response.data === 'number' ? response.data : 0;
    } catch (error) {
      console.error(
        "Error fetching total leave balance:",
        error.response? error.response.data : error.message
      );
      return 0;
    }
  };

  return useMemo(
    () => ({
      addLeaveEmployee,
      getTicketLeaveAvailablity,
      getExperince,
      getAnnualLeave,
    }),
    []
  );
};

export default useAddLeaveEmployee;
